<template>
<div class="no_result_container">
  <!-- <svg v-if="!isNoResultFeed" @click="closePage" class="back_icon" xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" style="width:1em;height:1em;vertical-align:middle"><path fill-rule="nonzero" d="M33.39 4.558a1.976 1.976 0 0 0-2.684-.063l-.124.119-15.196 15.918a5.026 5.026 0 0 0-.164 6.75l.163.18 15.197 15.924c.76.796 2.017.821 2.808.056.75-.725.811-1.9.17-2.698l-.114-.13L18.249 24.69a1.005 1.005 0 0 1-.078-1.293l.079-.093L33.446 7.386a2.01 2.01 0 0 0-.056-2.828z"/></svg> -->
  <div :class="['content', isNoResultFeed ? 'feed' : '']">
    <img :src="noNetwork" alt="" />
    <div class="title">{{noResult.title}}</div>
    <div class="sub_title">{{noResult.subTitle}}</div>
    <div v-if="!isNoResultFeed" class="try_again" @click="$emit('tryAgain')">{{gettext('重试')}}</div>
  </div>
</div>
</template>

<script>
import noNetwork from "@/assets/images/abnormal/noNetwork.png";
export default {
  props: {
    isNoResultFeed: {
      type: Boolean,
      default: false
    },
    noResult: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    
  },
  data() {
    return {
      noNetwork
    }
  },
  computed: {},
  methods: {
    closePage() {
      console.log('我是关闭页面');
      this.SodaBridge('closePage');
    },
  }
}
</script>
<style lang="scss" scoped>
.no_result_container {
  padding-left: 32px;
  padding-right: 32px;
  overflow: hidden;
  .back_icon {
    margin-top: 115px;
    margin-left: 14px;
    width: 18.97px;
    height: 33.99px;
  }
  .content {
    width: 100%;
    height: calc(100vh - 176px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 300px;
      height: 300px;
    }
    &.feed {
      height: 700px;
      justify-content: flex-start;
      margin-top: 196px;
    }
    .title {
      height: 38px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      font-weight: 700;
    }
    .sub_title {
      margin-top: 16px;
      height: 29px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
    .try_again {
      margin-top: 32px;
      padding: 15.5px 32px 15.5px 32px;
      width: fit-content;
      height: 60px;
      border: 1px solid #FF8040;
      border-radius: 18px;
      height: 29px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      color: #FF8040;
      text-align: center;
      font-weight: 700;
    }
  }
}
</style>